// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import GlobalStyleController from "./global_style_controller"
import FilterController from "./filter_controller"
import ShowhideController from "./showhide_controller"
import TurnstileController from "./turnstile_controller"
application.register("hello", HelloController)
application.register("global_style", GlobalStyleController)
application.register("filter", FilterController)
application.register("showhide", ShowhideController)
// application.register("turnstile", TurnstileController)